module.exports = __webpack_public_path__ + "static/media/apps.2629df73.svg";